{
  "page": 1,
  "results": [
    {
      "adult": false,
      "backdrop_path": "/2I5eBh98Q4aPq8WdQrHdTC8ARhY.jpg",
      "id": 569094,
      "title": "Spider-Man: Across the Spider-Verse",
      "original_language": "en",
      "original_title": "Spider-Man: Across the Spider-Verse",
      "overview": "After reuniting with Gwen Stacy, Brooklyn’s full-time, friendly neighborhood Spider-Man is catapulted across the Multiverse, where he encounters the Spider Society, a team of Spider-People charged with protecting the Multiverse’s very existence. But when the heroes clash on how to handle a new threat, Miles finds himself pitted against the other Spiders and must set out on his own to save those he loves most.",
      "poster_path": "/8Vt6mWEReuy4Of61Lnj5Xj704m8.jpg",
      "media_type": "movie",
      "genre_ids": [28, 12, 16, 878],
      "popularity": 2824.652,
      "release_date": "2023-05-31",
      "video": false,
      "vote_average": 8.795,
      "vote_count": 882
    },
    {
      "adult": false,
      "backdrop_path": "/h8gHn0OzBoaefsYseUByqsmEDMY.jpg",
      "id": 603692,
      "title": "John Wick: Chapter 4",
      "original_language": "en",
      "original_title": "John Wick: Chapter 4",
      "overview": "With the price on his head ever increasing, John Wick uncovers a path to defeating The High Table. But before he can earn his freedom, Wick must face off against a new enemy with powerful alliances across the globe and forces that turn old friends into foes.",
      "poster_path": "/vZloFAK7NmvMGKE7VkF5UHaz0I.jpg",
      "media_type": "movie",
      "genre_ids": [28, 53, 80],
      "popularity": 4242.15,
      "release_date": "2023-03-22",
      "video": false,
      "vote_average": 8.0,
      "vote_count": 2742
    },
    {
      "adult": false,
      "backdrop_path": "/2klQ1z1fcHGgQPevbEQdkCnzyuS.jpg",
      "id": 502356,
      "title": "The Super Mario Bros. Movie",
      "original_language": "en",
      "original_title": "The Super Mario Bros. Movie",
      "overview": "While working underground to fix a water main, Brooklyn plumbers—and brothers—Mario and Luigi are transported down a mysterious pipe and wander into a magical new world. But when the brothers are separated, Mario embarks on an epic quest to find Luigi.",
      "poster_path": "/qNBAXBIQlnOThrVvA6mA2B5ggV6.jpg",
      "media_type": "movie",
      "genre_ids": [16, 10751, 12, 14, 35],
      "popularity": 3185.383,
      "release_date": "2023-04-05",
      "video": false,
      "vote_average": 7.815,
      "vote_count": 4433
    },
    {
      "adult": false,
      "backdrop_path": "/4t0oBFrJyweYPt0hocW6RUa0b6H.jpg",
      "id": 385687,
      "title": "Fast X",
      "original_language": "en",
      "original_title": "Fast X",
      "overview": "Over many missions and against impossible odds, Dom Toretto and his family have outsmarted, out-nerved and outdriven every foe in their path. Now, they confront the most lethal opponent they've ever faced: A terrifying threat emerging from the shadows of the past who's fueled by blood revenge, and who is determined to shatter this family and destroy everything—and everyone—that Dom loves, forever.",
      "poster_path": "/1E5baAaEse26fej7uHcjOgEE2t2.jpg",
      "media_type": "movie",
      "genre_ids": [28, 80, 53],
      "popularity": 2184.233,
      "release_date": "2023-05-17",
      "video": false,
      "vote_average": 7.18,
      "vote_count": 875
    },
    {
      "adult": false,
      "backdrop_path": "/1IM8i8HiomFC4y6NRyBuDrHJWg3.jpg",
      "id": 447277,
      "title": "The Little Mermaid",
      "original_language": "en",
      "original_title": "The Little Mermaid",
      "overview": "The youngest of King Triton’s daughters, and the most defiant, Ariel longs to find out more about the world beyond the sea, and while visiting the surface, falls for the dashing Prince Eric. With mermaids forbidden to interact with humans, Ariel makes a deal with the evil sea witch, Ursula, which gives her a chance to experience life on land, but ultimately places her life – and her father’s crown – in jeopardy.",
      "poster_path": "/ym1dxyOk4jFcSl4Q2zmRrA5BEEN.jpg",
      "media_type": "movie",
      "genre_ids": [12, 10751, 14, 10749],
      "popularity": 1331.68,
      "release_date": "2023-05-18",
      "video": false,
      "vote_average": 6.077,
      "vote_count": 539
    },
    {
      "adult": false,
      "backdrop_path": "/bqMWZ5hB7bcI1KK2TH29odwCgWX.jpg",
      "id": 493529,
      "title": "Dungeons & Dragons: Honor Among Thieves",
      "original_language": "en",
      "original_title": "Dungeons & Dragons: Honor Among Thieves",
      "overview": "A charming thief and a band of unlikely adventurers undertake an epic heist to retrieve a lost relic, but things go dangerously awry when they run afoul of the wrong people.",
      "poster_path": "/A7AoNT06aRAc4SV89Dwxj3EYAgC.jpg",
      "media_type": "movie",
      "genre_ids": [12, 14, 35],
      "popularity": 427.385,
      "release_date": "2023-03-23",
      "video": false,
      "vote_average": 7.459,
      "vote_count": 1619
    },
    {
      "adult": false,
      "backdrop_path": "/rH3jY9JN9krUyE0Q3WLNtujMs8.jpg",
      "id": 667538,
      "title": "Transformers: Rise of the Beasts",
      "original_language": "en",
      "original_title": "Transformers: Rise of the Beasts",
      "overview": "A '90s globetrotting adventure that introduces the Maximals, Predacons, and Terrorcons to the existing battle on earth between Autobots and Decepticons.",
      "poster_path": "/gPbM0MK8CP8A174rmUwGsADNYKD.jpg",
      "media_type": "movie",
      "genre_ids": [28, 12, 878],
      "popularity": 838.469,
      "release_date": "2023-06-06",
      "video": false,
      "vote_average": 8.2,
      "vote_count": 60
    },
    {
      "adult": false,
      "backdrop_path": "/q3IK7KJPdfl8AeJnBvB1AQbIhBM.jpg",
      "id": 447365,
      "title": "Guardians of the Galaxy Vol. 3",
      "original_language": "en",
      "original_title": "Guardians of the Galaxy Vol. 3",
      "overview": "Peter Quill, still reeling from the loss of Gamora, must rally his team around him to defend the universe along with protecting one of their own. A mission that, if not completed successfully, could quite possibly lead to the end of the Guardians as we know them.",
      "poster_path": "/r2J02Z2OpNTctfOSN1Ydgii51I3.jpg",
      "media_type": "movie",
      "genre_ids": [878, 12, 28],
      "popularity": 1007.249,
      "release_date": "2023-05-03",
      "video": false,
      "vote_average": 8.126,
      "vote_count": 1863
    },
    {
      "adult": false,
      "backdrop_path": "/m8JTwHFwX7I7JY5fPe4SjqejWag.jpg",
      "id": 640146,
      "title": "Ant-Man and the Wasp: Quantumania",
      "original_language": "en",
      "original_title": "Ant-Man and the Wasp: Quantumania",
      "overview": "Super-Hero partners Scott Lang and Hope van Dyne, along with with Hope's parents Janet van Dyne and Hank Pym, and Scott's daughter Cassie Lang, find themselves exploring the Quantum Realm, interacting with strange new creatures and embarking on an adventure that will push them beyond the limits of what they thought possible.",
      "poster_path": "/qnqGbB22YJ7dSs4o6M7exTpNxPz.jpg",
      "media_type": "movie",
      "genre_ids": [28, 12, 878],
      "popularity": 1099.679,
      "release_date": "2023-02-15",
      "video": false,
      "vote_average": 6.491,
      "vote_count": 3166
    },
    {
      "adult": false,
      "backdrop_path": "/vQ5T84t8h4N2xAswNFW9fkVIyZq.jpg",
      "id": 536437,
      "title": "Hypnotic",
      "original_language": "en",
      "original_title": "Hypnotic",
      "overview": "A detective becomes entangled in a mystery involving his missing daughter and a secret government program while investigating a string of reality-bending crimes.",
      "poster_path": "/3IhGkkalwXguTlceGSl8XUJZOVI.jpg",
      "media_type": "movie",
      "genre_ids": [80, 9648, 53],
      "popularity": 685.244,
      "release_date": "2023-05-11",
      "video": false,
      "vote_average": 6.558,
      "vote_count": 120
    },
    {
      "adult": false,
      "backdrop_path": "/suw8eyL3YwE4wfzPQ0cLR02k0Gh.jpg",
      "id": 76600,
      "title": "Avatar: The Way of Water",
      "original_language": "en",
      "original_title": "Avatar: The Way of Water",
      "overview": "Set more than a decade after the events of the first film, learn the story of the Sully family (Jake, Neytiri, and their kids), the trouble that follows them, the lengths they go to keep each other safe, the battles they fight to stay alive, and the tragedies they endure.",
      "poster_path": "/t6HIqrRAclMCA60NsSmeqe9RmNV.jpg",
      "media_type": "movie",
      "genre_ids": [878, 12, 28],
      "popularity": 1062.492,
      "release_date": "2022-12-14",
      "video": false,
      "vote_average": 7.7,
      "vote_count": 8364
    },
    {
      "adult": false,
      "backdrop_path": "/aAgGrfBwna1nO4M2USxwFgK5O0t.jpg",
      "id": 713704,
      "title": "Evil Dead Rise",
      "original_language": "en",
      "original_title": "Evil Dead Rise",
      "overview": "A reunion between two estranged sisters gets cut short by the rise of flesh-possessing demons, thrusting them into a primal battle for survival as they face the most nightmarish version of family imaginable.",
      "poster_path": "/5ik4ATKmNtmJU6AYD0bLm56BCVM.jpg",
      "media_type": "movie",
      "genre_ids": [53, 27],
      "popularity": 1148.359,
      "release_date": "2023-04-12",
      "video": false,
      "vote_average": 7.069,
      "vote_count": 1541
    },
    {
      "adult": false,
      "backdrop_path": "/94TIUEhuwv8PhdIADEvSuwPljS5.jpg",
      "id": 840326,
      "title": "Sisu",
      "original_language": "fi",
      "original_title": "Sisu",
      "overview": "Deep in the wilderness of Lapland, Aatami Korpi is searching for gold but after he stumbles upon Nazi patrol, a breathtaking and gold-hungry chase through the destroyed and mined Lapland wilderness begins.",
      "poster_path": "/ygO9lowFMXWymATCrhoQXd6gCEh.jpg",
      "media_type": "movie",
      "genre_ids": [28, 10752],
      "popularity": 1021.56,
      "release_date": "2023-01-27",
      "video": false,
      "vote_average": 7.425,
      "vote_count": 611
    },
    {
      "adult": false,
      "backdrop_path": "/6GIpI3X65J6DT2nSTSga9LnanGJ.jpg",
      "id": 298618,
      "title": "The Flash",
      "original_language": "en",
      "original_title": "The Flash",
      "overview": "When his attempt to save his family inadvertently alters the future, Barry Allen becomes trapped in a reality in which General Zod has returned and there are no Super Heroes to turn to. In order to save the world that he is in and return to the future that he knows, Barry's only hope is to race for his life. But will making the ultimate sacrifice be enough to reset the universe?",
      "poster_path": "/67PmbAViFCW3obXxr5Utm9wArIP.jpg",
      "media_type": "movie",
      "genre_ids": [878, 28, 12],
      "popularity": 370.219,
      "release_date": "2023-06-05",
      "video": false,
      "vote_average": 6.4,
      "vote_count": 14
    },
    {
      "adult": false,
      "backdrop_path": "/xqYfwHPxNiGynos9WJoazDMPP1e.jpg",
      "id": 961718,
      "title": "Medellin",
      "original_language": "fr",
      "original_title": "Medellin",
      "overview": "To save his little brother from the hands of dangerous narcos of the Medellín cartel, Reda has a plan that is as simple as it is totally insane: put together a team and raid Colombia. But this adventure is going to get completely out of control when he decides to kidnap the son of the cartel leader to exchange him for his brother's life.",
      "poster_path": "/jKFOQ5LNQuIWGLdB2WhVlSUcS6F.jpg",
      "media_type": "movie",
      "genre_ids": [28, 35],
      "popularity": 188.924,
      "release_date": "2023-06-01",
      "video": false,
      "vote_average": 5.6,
      "vote_count": 54
    },
    {
      "adult": false,
      "backdrop_path": "/jqwM0nhOLEFI1HHBabwr80Od3TC.jpg",
      "id": 324857,
      "title": "Spider-Man: Into the Spider-Verse",
      "original_language": "en",
      "original_title": "Spider-Man: Into the Spider-Verse",
      "overview": "Miles Morales is juggling his life between being a high school student and being a spider-man. When Wilson \"Kingpin\" Fisk uses a super collider, others from across the Spider-Verse are transported to this dimension.",
      "poster_path": "/iiZZdoQBEYBv6id8su7ImL0oCbD.jpg",
      "media_type": "movie",
      "genre_ids": [28, 12, 16, 878],
      "popularity": 894.653,
      "release_date": "2018-12-06",
      "video": false,
      "vote_average": 8.404,
      "vote_count": 12979
    },
    {
      "adult": false,
      "backdrop_path": "/nDxJJyA5giRhXx96q1sWbOUjMBI.jpg",
      "id": 594767,
      "title": "Shazam! Fury of the Gods",
      "original_language": "en",
      "original_title": "Shazam! Fury of the Gods",
      "overview": "Billy Batson and his foster siblings, who transform into superheroes by saying \"Shazam!\", are forced to get back into action and fight the Daughters of Atlas, who they must stop from using a weapon that could destroy the world.",
      "poster_path": "/A3ZbZsmsvNGdprRi2lKgGEeVLEH.jpg",
      "media_type": "movie",
      "genre_ids": [35, 28, 14],
      "popularity": 827.244,
      "release_date": "2023-03-15",
      "video": false,
      "vote_average": 6.731,
      "vote_count": 1894
    },
    {
      "adult": false,
      "backdrop_path": "/eSVu1FvGPy86TDo4hQbpuHx55DJ.jpg",
      "id": 700391,
      "title": "65",
      "original_language": "en",
      "original_title": "65",
      "overview": "65 million years ago, the only 2 survivors of a spaceship from Somaris that crash-landed on Earth must fend off dinosaurs and reach the escape vessel in time before an imminent asteroid strike threatens to destroy the planet.",
      "poster_path": "/rzRb63TldOKdKydCvWJM8B6EkPM.jpg",
      "media_type": "movie",
      "genre_ids": [878, 28, 12, 53],
      "popularity": 231.895,
      "release_date": "2023-03-02",
      "video": false,
      "vote_average": 6.229,
      "vote_count": 1181
    },
    {
      "adult": false,
      "backdrop_path": "/vPIY3d37vST3oCGvXpXOfuXgMXG.jpg",
      "id": 1098110,
      "title": "Blood & Gold",
      "original_language": "de",
      "original_title": "Blood & Gold",
      "overview": "At the end of World War II, a German soldier is looking for his daughter while an SS troop is looking for a Jewish treasure.",
      "poster_path": "/xayG1dbIjJkmvimekx6TNrMOXmA.jpg",
      "media_type": "movie",
      "genre_ids": [28, 18, 10752],
      "popularity": 890.098,
      "release_date": "2023-04-21",
      "video": false,
      "vote_average": 6.66,
      "vote_count": 131
    },
    {
      "adult": false,
      "backdrop_path": "/i1eghEBiC0gN4KnwuUGC2fNiX1f.jpg",
      "id": 552688,
      "title": "The Mother",
      "original_language": "en",
      "original_title": "The Mother",
      "overview": "A deadly female assassin comes out of hiding to protect the daughter that she gave up years before, while on the run from dangerous men.",
      "poster_path": "/vnRthEZz16Q9VWcP5homkHxyHoy.jpg",
      "media_type": "movie",
      "genre_ids": [28, 53],
      "popularity": 767.247,
      "release_date": "2023-05-04",
      "video": false,
      "vote_average": 6.766,
      "vote_count": 721
    }
  ],
  "total_pages": 1000,
  "total_results": 20000
}
